module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-right-top-backplates-remnants.8c9cdda8.png";